module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-account"
  }, [_c('div', {
    staticClass: "infos pane"
  }, [_c('h1', {
    staticClass: "email"
  }, [_vm._v(_vm._s(_vm.user.email || _vm.user.cellphone))]), _vm._v(" "), _c('div', {
    staticClass: "sub-infos"
  }, [_c('div', {
    staticClass: "avatar img",
    style: ({
      'backgroundImage': 'url(' + _vm.user.profile_picture + ')'
    })
  }, [_c('ssuploader', {
    staticClass: "avatar-uploader-btn",
    attrs: {
      "defaultBtn": false,
      "url": _vm.avatarUploadUrl,
      "data": {
        '_method': 'PUT'
      },
      "name": "user[profile_picture]",
      "extensions": _vm.extensions,
      "accept": _vm.accept,
      "uploading": _vm.avatarOnUploading
    },
    on: {
      "update:uploading": function($event) {
        _vm.avatarOnUploading = $event
      },
      "complete": _vm.avatarUploadComplete
    }
  }), _vm._v(" "), (_vm.avatarOnUploading) ? _c('div', {
    staticClass: "ppj-icon-spinner",
    staticStyle: {
      "margin-left": "42.222222%",
      "margin-top": "42.2222222%"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('table', {
    staticClass: "text-table"
  }, [_c('tr', [_c('td', {
    staticClass: "label"
  }, [_vm._v("用户名称")]), _vm._v(" "), _c('td', {
    staticClass: "data"
  }, [_vm._v("\n            " + _vm._s(_vm.user.nickname) + "\n            "), _c('a', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.rename()
      }
    }
  }, [_vm._v("修改")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("账户类型")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.$store.getters['user/organization'] ? '企业用户' : '个人账户') + "\n            ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("手机号")]), _vm._v(" "), (_vm.user.cellphone) ? _c('td', [_vm._v("\n            " + _vm._s(_vm.user.cellphone) + "\n            "), _c('a', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.cellphoneDialog()
      }
    }
  }, [_vm._v("修改")])]) : _c('td', [_vm._v("\n            无\n            "), _c('a', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.cellphoneDialog()
      }
    }
  }, [_vm._v("绑定手机号")])])]), _vm._v(" "), (_vm.user.occupation_verified) ? _c('tr', [_c('td', [_vm._v("教师认证")]), _vm._v(" "), _c('td', [_c('span', [_vm._v("已认证")]), _vm._v(" "), _c('router-link', {
    staticClass: "text-btn",
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "to": "/teacher"
    }
  }, [_vm._v("去认证")])], 1)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "quota pane"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("账户额度")]), _vm._v(" "), _c('div', {
    staticClass: "quota-item"
  }, [(_vm.quotas.permanents === null) ? _c('span', {
    staticClass: "numbers"
  }, [_vm._v("无限制")]) : _c('span', {
    staticClass: "numbers"
  }, [_vm._v("\n          " + _vm._s(_vm.quotas.permanents_left) + "/" + _vm._s(_vm.quotas.permanents) + "\n      ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "quota-item"
  }, [(_vm.quotas.logos === null) ? _c('span', {
    staticClass: "numbers"
  }, [_vm._v("无限制")]) : _c('span', {
    staticClass: "numbers"
  }, [_vm._v("\n            " + _vm._s(_vm.quotas.logos_left) + "/" + _vm._s(_vm.quotas.logos) + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("LOGO 设置")])]), _vm._v(" "), _c('div', {
    staticClass: "quota-item"
  }, [(_vm.quotas.exports === null) ? _c('span', {
    staticClass: "numbers"
  }, [_vm._v("无限制")]) : _c('span', {
    staticClass: "numbers"
  }, [_vm._v("\n            " + _vm._s(_vm.quotas.exports_left) + "/" + _vm._s(_vm.quotas.exports) + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("导出次数")])])]), _vm._v(" "), _c('div', {
    staticClass: "actions pane"
  }, [_c('table', [_c('tr', [_c('td', [_vm._v("微信绑定")]), _vm._v(" "), _c('td', [(_vm.user.wechat_nickname) ? _c('span', {
    staticStyle: {
      "margin-left": "1.5em"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.user.wechat_nickname) + "\n              "), _c('a', {
    staticClass: "text-btn",
    on: {
      "click": _vm.wxDisconnected
    }
  }, [_vm._v("解除绑定")])]) : _c('a', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.wxConnectionDialog()
      }
    }
  }, [_vm._v("去绑定")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("密码")]), _vm._v(" "), _c('td', [_c('a', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.changePasswordDialog()
      }
    }
  }, [_vm._v("修改密码")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "sub-title"
  }, [_vm._v(_vm._s(_vm.$t('projectQuota')))])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19c2dd76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/account/index.vue
// module id = 901
// module chunks = 3